/**
 * Share badge achievement to LinkedIn using the badge share page URL
 * @param {object} badgeData - Badge data with name, description, id, etc.
 * @param {function} dispatch - Redux dispatch function
 * @param {function} acknowledgeBadgePopup - Action creator for acknowledging badge popup
 * @param {function} trackBadgeShare - Action creator for tracking badge share
 * @return {boolean} - Success status
 */
export const shareToLinkedIn = (badgeData, dispatch, acknowledgeBadgePopup, trackBadgeShare) => {
  const { badgeId, badgeName, badgeDescription } = badgeData || {
    badgeId: 1,
    badgeName: 'Consistency Champion',
    badgeDescription: 'Complete Language Practice sessions consistently'
  };

  // Create the shareable URL that points to our badge share page
  const shareableUrl = `${window.location.origin}/share/badge/${badgeId}`;

  // Format the content to share
  const title = `I earned the ${badgeName} badge on Chatterbox!`;
  const text = `${badgeDescription || 'I achieved a milestone in my language learning journey with Chatterbox.'}`;

  // LinkedIn sharing parameters - using feed with shareActive parameter
  const fullText = `${title} ${text}`;
  const encodedText = encodeURIComponent(fullText);
  const encodedUrl = encodeURIComponent(shareableUrl); // Use the badge share page URL here
  const linkedInShareUrl = `https://www.linkedin.com/feed/?shareActive=true&text=${encodedText}&url=${encodedUrl}`;

  console.log('LinkedIn Share URL:', linkedInShareUrl);

  // Open LinkedIn share dialog in a new window
  window.open(linkedInShareUrl, 'linkedin-share-dialog', 'width=600,height=600,toolbar=0,location=0,menubar=0');

  // Track this share event with analytics
  if (typeof window.analytics !== 'undefined') {
    window.analytics.track('Badge Shared', {
      badgeName,
      platform: 'LinkedIn'
    });
  }

  // If dispatch and actions were provided, update Redux store
  if (dispatch && acknowledgeBadgePopup && trackBadgeShare) {
    // Track the share in our Redux store
    dispatch(trackBadgeShare(badgeId, 'LinkedIn'));

    // Mark the badge popup as acknowledged
    dispatch(acknowledgeBadgePopup(badgeId));
  }

  return true;
};
